import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Order } from 'src/app/models/orders-model/order.model';
import { PriceToStringPipe } from 'src/app/pipes/price-to-string-pipe/price-to-string.pipe';
import { OrderBankTransactionDialogComponent } from '../order-bank-transaction-dialog/order-bank-transaction-dialog.component';
import { OrderTicketPreviewDialogComponent } from '../order-ticket-preview-dialog/order-ticket-preview-dialog.component';

@Component({
  selector: 'app-orders-list-card',
  templateUrl: './orders-list-card.component.html',
  styleUrls: ['./orders-list-card.component.scss']
})
export class OrdersListCardComponent implements OnInit {

  @Input() data: Order[];
  creationDateOrder;
  centerNameOrder;
  deviceNameOrder;
  appOrder;
  statusOrder;
  paymentTypeOrder;
  amountOrder;
  nbArticlesOrder;

  constructor(private priceToStringPipe: PriceToStringPipe,
              public dialog: MatDialog) { }

  ngOnInit() {
    this.resetSortOrders();
  }

  public resetSortOrders() {
    this.creationDateOrder = 0;
    this.centerNameOrder = 0;
    this.deviceNameOrder = 0;
    this.appOrder = 0;
    this.statusOrder = 0;
    this.paymentTypeOrder = 0;
    this.amountOrder = 0;
    this.nbArticlesOrder = 0;
  }

  public sortBy(attribute) {
    switch (attribute) {
      case 'creationDate':
        this.creationDateOrder = (this.creationDateOrder === 0) ? 1 : (this.creationDateOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.CreationDate = a.CreationDate ? a.CreationDate : 0;
            b.CreationDate = b.CreationDate ? b.CreationDate : 0;
            return (a.CreationDate < b.CreationDate) ? -this.creationDateOrder : (a.CreationDate) ? this.creationDateOrder : 0;
          });
        break;
      case 'centerName':
        this.centerNameOrder = (this.centerNameOrder === 0) ? 1 : (this.centerNameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.CenterName = a.CenterName ? a.CenterName : ' ';
            b.CenterName = b.CenterName ? b.CenterName : ' ';
            return (a.CenterName.toUpperCase() < b.CenterName.toUpperCase()) ? -this.centerNameOrder : (a.CenterName.toUpperCase() > b.CenterName.toUpperCase()) ? this.centerNameOrder : 0;
          });
        break;
      case 'deviceName':
        this.deviceNameOrder = (this.deviceNameOrder === 0) ? 1 : (this.deviceNameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.DeviceName = a.DeviceName ? a.DeviceName : ' ';
            b.DeviceName = b.DeviceName ? b.DeviceName : ' ';
            return (a.DeviceName.toUpperCase() < b.DeviceName.toUpperCase()) ? -this.deviceNameOrder : (a.DeviceName.toUpperCase() > b.DeviceName.toUpperCase()) ? this.deviceNameOrder : 0;
          });
        break;
      case 'appName':
        this.appOrder = (this.appOrder === 0) ? 1 : (this.appOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.App = a.App ? a.App : ' ';
            b.App = b.App ? b.App : ' ';
            return (a.App.toUpperCase() < b.App.toUpperCase()) ? -this.appOrder : (a.App.toUpperCase() > b.App.toUpperCase()) ? this.appOrder : 0;
          });
        break;
      case 'status':
        this.statusOrder = (this.statusOrder === 0) ? 1 : (this.statusOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            return (a.CurrentStatus.toUpperCase() < b.CurrentStatus.toUpperCase()) ? -this.statusOrder : (a.CurrentStatus.toUpperCase() > b.CurrentStatus.toUpperCase()) ? this.statusOrder : 0;
          });
        break;
      case 'paymentType':
        this.paymentTypeOrder = (this.paymentTypeOrder === 0) ? 1 : (this.paymentTypeOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.PaymentType = a.PaymentType ? a.PaymentType : ' ';
            b.PaymentType = b.PaymentType ? b.PaymentType : ' ';
            return (a.PaymentType.toUpperCase() < b.PaymentType.toUpperCase()) ? -this.paymentTypeOrder : (a.PaymentType.toUpperCase() > b.PaymentType.toUpperCase()) ? this.paymentTypeOrder : 0;
          });
        break;
      case 'amount':
        this.amountOrder = (this.amountOrder === 0) ? 1 : (this.amountOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            return (this.priceToStringPipe.transform(a.Amount, 'flat') < this.priceToStringPipe.transform(b.Amount, 'flat')) ? -this.amountOrder : (this.priceToStringPipe.transform(a.Amount, 'flat') > this.priceToStringPipe.transform(b.Amount, 'flat')) ? this.amountOrder : 0;
          });
        break;
      case 'nbArticles':
        this.nbArticlesOrder = (this.nbArticlesOrder === 0) ? 1 : (this.nbArticlesOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            return (a.NbArticles < b.NbArticles) ? -this.nbArticlesOrder : (a.NbArticles > b.NbArticles) ? this.nbArticlesOrder : 0;
          });
        break;
    }
  }

  public openBankTransaction(bankTransaction) {
    this.dialog.open(OrderBankTransactionDialogComponent, { data: { bankTransaction} });
  }

  public openTicketPreview(ticketPreview) {
    this.dialog.open(OrderTicketPreviewDialogComponent, { data: { ticketPreview } });
  }
}


